const STEPS = [
  {
    n: "01",
    title: "You send a query",
    body: "Drop a few bullet points about what you want. No deposit, no commitment.",
  },
  {
    n: "02",
    title: "I reply with a quote",
    body: "You get a fixed, written quote back — usually within a working day. No hourly billing games.",
  },
  {
    n: "03",
    title: "You see it before you pay",
    body: "Once you agree, I build it and send screenshots of the finished site so you know exactly what you're getting.",
  },
  {
    n: "04",
    title: "Pay, go live, review",
    body: "The site goes live the moment payment lands. You get one round of revisions to flag anything you'd like changed.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="border-t border-[#E5E0D8] bg-[#FAF9F6]">
      <div className="oak-container oak-section">
        <div className="max-w-2xl">
          <p className="text-sm uppercase tracking-[0.18em] text-[#5C665F]">How it works</p>
          <h2 className="font-heading font-bold text-3xl md:text-5xl tracking-tight mt-3 text-[#1A3622]">
            A simple four-step process.
            <br />
            No surprises.
          </h2>
        </div>

        <ol className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
          {STEPS.map((s, i) => (
            <li key={s.n} data-testid={`process-step-${i}`} className="relative">
              <div className="font-heading font-extrabold text-5xl md:text-6xl tracking-tight text-[#C17F59]/40 select-none">
                {s.n}
              </div>
              <h3 className="font-heading font-bold text-xl mt-3 text-[#1A3622]">{s.title}</h3>
              <p className="text-[15px] leading-relaxed text-[#5C665F] mt-2 max-w-xs">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
